import { createSlice } from '@reduxjs/toolkit';
import { getAllParams } from '../../../shared/helpers/WVQuery';

const ProspectsReducer = createSlice({
  name: 'prospects',
  initialState: {
    filters: {
      programCountry: getAllParams('filters.programCountry', { pathname: '/prospects' }).map(value => ({ value })),
      country: getAllParams('filters.country', { pathname: '/prospects' }).map(value => ({ value })),
    },
  },
  reducers: {
    updateFilters(state, action) {
      const { data } = action.payload;
      state.filters[data.property] = data.value;
    },
  },
});

export const {
  updateFilters,
} = ProspectsReducer.actions;

export const updateFilter = (property, value) => async (dispatch) => {
  dispatch(updateFilters({ data: { property, value } }));
};

export default ProspectsReducer.reducer;
